import { CarouselIndicators as _CarouselIndicators, CarouselIndicatorsProps as _CarouselIndicatorsProps } from "reactstrap";

    export const CarouselIndicators = _CarouselIndicators;
    export type CarouselIndicatorsProps = _CarouselIndicatorsProps;
    